"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavContent = void 0;
const react_1 = __importStar(require("react"));
const helpers_1 = require("../../../lib/helpers");
const NavContext_1 = __importDefault(require("../../../contexts/NavContext"));
const withJourney_1 = __importDefault(require("../../../hocs/withJourney"));
const createJourneyComponent_1 = require("../../../lib/createJourneyComponent");
exports.NavContent = createJourneyComponent_1.createJourneyComponent('j-nav-content', 'div');
const Nav = (props) => {
    const { children } = props;
    const [drawerOpen, setDrawerOpen] = react_1.useState(false);
    const collapseContent = helpers_1.hasChildComponent(props, 'j-nav-content');
    const contextValue = react_1.useMemo(() => ({ drawerOpen, setDrawerOpen, inNav: true }), [drawerOpen]);
    return (react_1.default.createElement(NavContext_1.default.Provider, { value: contextValue },
        react_1.default.createElement("nav", Object.assign({}, helpers_1.usePrimitiveProps(props)),
            react_1.default.createElement(exports.NavContent, { collapse: collapseContent }, children))));
};
exports.default = withJourney_1.default('j-nav', Nav, { wrapsHref: false, collapseInModal: 'hidden' });
